import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import common_ar from 'src/setup/i18n/locales/ar/common.json';
import common_en from 'src/setup/i18n/locales/en/common.json';
import home_ar from 'src/setup/i18n/locales/ar/home.json';
import home_en from 'src/setup/i18n/locales/en/home.json';
import services_ar from 'src/setup/i18n/locales/ar/services.json';
import services_en from 'src/setup/i18n/locales/en/services.json';
import contact_ar from 'src/setup/i18n/locales/ar/contact.json';
import contact_en from 'src/setup/i18n/locales/en/contact.json';
import about_ar from 'src/setup/i18n/locales/ar/about.json';
import about_en from 'src/setup/i18n/locales/en/about.json';

import ed_ar from 'src/setup/i18n/locales/ar/electronicDiagnostics.json';
import ed_en from 'src/setup/i18n/locales/en/electronicDiagnostics.json';



i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        supportedLngs: ["en", "ar"],
        resources: {
            ar: {
                common: common_ar,
                home: home_ar,
                services: services_ar,
                contact: contact_ar,
                about: about_ar,
                ed: ed_ar
            },
            en: {
                common: common_en,
                home: home_en,
                about: about_en,
                contact: contact_en,
                services: services_en,
                ed: ed_en
            }
        },
        ns: ['common', 'home', 'services', 'about', 'contact', 'ed'],
        defaultNS: 'common',
        debug: process.env.NODE_ENV === "development",

    });


export default i18n;